import { microFrontendMetadataFileName } from './constants'

export type MicroFrontendFormat = 'esm'

export type MicroFrontendRuntime = 'vite'

export type MicroFrontendManifest = {
  version: string
  format: MicroFrontendFormat
  runtime: MicroFrontendRuntime
  hasCss: boolean
}

export type MicroFrontendMetadata = Partial<Pick<MicroFrontendManifest, 'format' | 'runtime' | 'hasCss'>>

export type MicroFrontendServerConfiguration = Record<string, MicroFrontendManifest>

export const getMicroFrontendMetadata = async (baseUrl: string): Promise<MicroFrontendMetadata | undefined> => {
  try {
    const response = await fetch(`${baseUrl}/${microFrontendMetadataFileName}`)
    if (!response.ok) {
      return undefined
    }

    const metadata: MicroFrontendMetadata = await response.json()
    return metadata
  } catch {
    return undefined
  }
}

export const mergeMicroFrontendMetadata = (
  manifest: MicroFrontendManifest,
  metadata?: MicroFrontendMetadata
): MicroFrontendManifest => ({
  ...manifest,
  format: metadata?.format ?? manifest.format,
  runtime: metadata?.runtime ?? manifest.runtime,
  hasCss: metadata?.hasCss ?? manifest.hasCss
})
